module.exports = __webpack_public_path__ + "static/media/shaking-hands-3098690__340.d0de964e.jpg";